package one.healthium.profile.ui.food.components

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.format
import kotlinx.datetime.format.MonthNames
import kotlinx.datetime.format.char
import one.healthium.base.utils.toLocalDateTime
import one.healthium.profile.ui.food.models.AmountUiModel
import one.healthium.profile.ui.food.models.FoodUiOptions
import one.healthium.ui.compose.components.AppProgressButton
import one.healthium.ui.compose.components.cupertino.PlatformDateFormat
import one.healthium.ui.compose.components.cupertino.defaultLocale
import one.healthium.ui.compose.theme.AppTheme
import kotlin.time.Instant

@Composable
fun FoodEditComponent(
    food: FoodUiOptions?,
    amount: AmountUiModel?,
    selectedDate: Instant,
    actionText: String,
    loading: Boolean,
    onActionClicked: (FoodUiOptions) -> Unit,
    onAmountChanged: (AmountUiModel) -> Unit,
    onTimeChanged: (Instant) -> Unit,
) {
    var selectDateEnabled by rememberSaveable { mutableStateOf(false) }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .verticalScroll(rememberScrollState())
            .navigationBarsPadding()
            .testTag("add_food_screen"),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        if (food != null) {
            FoodDetails(food)
        }
        Spacer(Modifier.height(12.dp))
        Text(
            modifier = Modifier.fillMaxWidth().padding(horizontal = 12.dp),
            text = "Details",
            style = AppTheme.textStyles.secondary_17_500,
            color = AppTheme.colors.text100,
            textAlign = TextAlign.Start,
        )
        Spacer(Modifier.height(6.dp))
        if (amount != null) {
            DetailsRow(
                title = "Amount",
                value = amount.displayValue,
                onClick = { selectDateEnabled = false },
            )
            Spacer(Modifier.height(6.dp))
        }
        val defaultLocale = defaultLocale()
        DetailsRow(
            title = "Log time",
            value = remember(selectedDate) {
                if (PlatformDateFormat.is24HourFormat(defaultLocale)) {
                    selectedDate.toLocalDateTime().format(dateFormat24)
                } else {
                    selectedDate.toLocalDateTime().format(dateFormat)
                }
            },
            onClick = { selectDateEnabled = true },
        )
        Spacer(Modifier.height(24.dp))
        AppProgressButton(
            modifier = Modifier.defaultMinSize(minWidth = 176.dp).testTag("add_food_button"),
            enabled = food != null,
            loading = loading,
            text = actionText,
            onClick = {
                food?.let(onActionClicked)
            },
        )
        Spacer(Modifier.height(12.dp))
        Spacer(Modifier.weight(1f))
        if (selectDateEnabled) {
            DatePicker(
                modifier = Modifier.fillMaxWidth(),
                date = selectedDate,
                onValueChanged = { date ->
                    onTimeChanged(date)
                },
            )
        } else if (amount != null) {
            AmountPicker(
                value = amount,
                onValueChanged = onAmountChanged,
            )
        }
        Spacer(Modifier.height(24.dp))
    }
}

private val dateFormat = LocalDateTime.Format {
    amPmHour()
    char(':')
    minute()
    char(' ')
    amPmMarker("AM", "PM")
    char(',')
    char(' ')
    monthName(MonthNames.ENGLISH_FULL)
    char(' ')
    dayOfMonth()
    char(',')
    char(' ')
    year()
}

private val dateFormat24 = LocalDateTime.Format {
    hour()
    char(':')
    minute()
    char(',')
    char(' ')
    dayOfMonth()
    char(' ')
    monthName(MonthNames.ENGLISH_FULL)
    char(' ')
    year()
}
